function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useRef, useState } from 'react';
import { Alert } from 'ui/alert/Alert';
import HTMLReactParser from 'html-react-parser';
import { useNetworkService } from 'hooks/use-network-service';
import { Modal } from '@collaborator/npm_modules/dist/components/modal';
import { Button } from 'components/button/Button';
import { translate } from '@collaborator/npm_modules/dist/components/translate';
import { useDispatch } from 'react-redux';
import { appRemoveAlert } from 'moduleBase/actions/remove-alert';

var AlertInformation = function AlertInformation(_ref) {
  var content = _ref.content,
      keyProp = _ref.keyProp,
      variant = _ref.variant,
      closeUrl = _ref.closeUrl,
      modalHeader = _ref.modalHeader,
      modalContent = _ref.modalContent,
      leftButtonText = _ref.leftButtonText,
      leftButtonUrl = _ref.leftButtonUrl,
      rightButtonText = _ref.rightButtonText,
      rightButtonUrl = _ref.rightButtonUrl;
  var networkService = useNetworkService();
  var dispatch = useDispatch();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalVisible = _useState2[0],
      setModalVisible = _useState2[1];

  var ref = useRef();
  var isHaveModal = modalHeader && modalContent && content.includes('data-toggle');
  useEffect(function () {
    var _ref$current;

    if (!isHaveModal) {
      return;
    }

    var listener = function listener() {
      return setModalVisible(true);
    };

    var linkEl = ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector('[data-toggle="modal"]');
    linkEl === null || linkEl === void 0 ? void 0 : linkEl.addEventListener('click', listener); // eslint-disable-next-line consistent-return

    return function () {
      linkEl === null || linkEl === void 0 ? void 0 : linkEl.removeEventListener('click', listener);
    };
  }, []);

  var handlerClose = function handlerClose() {
    return new Promise(function (resolve) {
      networkService.postSimple(closeUrl, {
        key: keyProp
      }).then(function () {
        resolve();
        dispatch(appRemoveAlert(keyProp));
      });
    });
  };

  var hideModalHandler = function hideModalHandler() {
    setModalVisible(false);
  };

  var renderModal = function renderModal() {
    var renderLeftButton = function renderLeftButton() {
      if (!leftButtonText) {
        return null;
      }

      var btnText = leftButtonText !== null && leftButtonText !== void 0 ? leftButtonText : translate.translate('CD-7840', 'Dismiss');

      if (!leftButtonUrl) {
        return /*#__PURE__*/React.createElement(Button, {
          primary: true,
          additionalClassName: "fs-16",
          onClick: hideModalHandler
        }, btnText);
      }

      return /*#__PURE__*/React.createElement("a", {
        href: leftButtonUrl,
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement(Button, {
        primary: true
      }, btnText));
    };

    var renderRightButton = function renderRightButton() {
      if (!rightButtonText) {
        return null;
      }

      var btnText = rightButtonText !== null && rightButtonText !== void 0 ? rightButtonText : translate.translate('CD-7840', 'Dismiss');

      if (!rightButtonUrl) {
        return /*#__PURE__*/React.createElement(Button, {
          primary: true,
          additionalClassName: "fs-16",
          onClick: hideModalHandler
        }, btnText);
      }

      return /*#__PURE__*/React.createElement("a", {
        href: rightButtonUrl,
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement(Button, {
        primary: true
      }, btnText));
    };

    return /*#__PURE__*/React.createElement(Modal, {
      show: modalVisible,
      onHide: hideModalHandler
    }, /*#__PURE__*/React.createElement(Modal.Title, {
      onHide: hideModalHandler
    }, modalHeader), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
      className: "fs-16"
    }, HTMLReactParser(modalContent))), /*#__PURE__*/React.createElement(Modal.Footer, {
      className: "d-flex justify-content-sm-center flex-column flex-sm-row flex-wrap m-b-30 m-l-15 m-r-15 gap-10px"
    }, renderLeftButton(), renderRightButton()));
  };

  return /*#__PURE__*/React.createElement(Alert, {
    variant: variant,
    onClose: handlerClose,
    dismissible: true,
    ref: ref
  }, HTMLReactParser(content), isHaveModal && renderModal());
};

export { AlertInformation };